module.exports = __webpack_public_path__ + "static/media/xmr.9749f027.svg";